import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocationNavigationService {
  private _locationId = new BehaviorSubject<string | null>(null);
  locationId$ = this._locationId.asObservable();

  openLocation(id: string) {
    this._locationId.next(id);
  }

  clear() {
    this._locationId.next(null);
  }
}
